"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const makeMyClasses = (transparent) => ({
    tooltip: {
        fontSize: 14,
        backgroundColor: lib_palette_1.default.HelixSecondaryBoldAccent.main + (transparent ? 'bb' : ''),
    },
});
function Tooltip(props) {
    const { minTipLength = 0, transparent = false, tip = '', children, placement, interactive = false, enterDelay = 200, style, arrow, noInnerDiv = false, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [transparent]);
    return (0, react_1.useMemo)(() => {
        if (minTipLength > 0 && tip.length <= minTipLength)
            return children;
        return (react_1.default.createElement(Tooltip_1.default, { style: style, interactive: interactive, TransitionProps: { timeout: 100 }, enterNextDelay: enterDelay, enterDelay: enterDelay, placement: placement, classes: myCss, title: tip, arrow: arrow }, !!noInnerDiv ? children : react_1.default.createElement("div", null, children)));
    }, [
        minTipLength,
        tip,
        children,
        style,
        interactive,
        enterDelay,
        placement,
        myCss,
        arrow,
        noInnerDiv,
    ]);
}
exports.Tooltip = Tooltip;
exports.default = Tooltip;
